import React from 'react';

function LinkedIn({
  width = '1rem',
  style,
  viewBox = '0 0 24 24',
  className,
  fill = 'currentColor',
}) {
  return (
    <svg
      width={width}
      style={style}
      height={width}
      viewBox={viewBox}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9062804 18.743146h3.007972v-5.1818005c0-1.3357962-.3169357-2.3468792-.9508069-3.0313047-.6338713-.68636979-1.4719036-1.0305269-2.5121525-1.0305269-1.180245 0-2.0882753.5074859-2.7202022 1.5244021h.0233327V9.70950807H9.74645149c.02722146.57165083.02722146 3.58545593 0 9.03363793h3.00797201v-5.0495819c0-.3305464.0311102-.5735952.0913863-.7291464.1322186-.3052693.3266576-.5619289.5872059-.7758118.2605484-.2119386.5813728-.3188801.9624733-.3188801 1.0071943 0 1.5107914.6824811 1.5107914 2.0435544v4.8298658zm-10.82053278 0h3.007972V9.70950807h-3.007972V18.743146zM8.28815866 6.92125219c-.00583317-.44915419-.16527318-.82442155-.46859809-1.11996889-.30332491-.29360296-.70581373-.44137663-1.20941085-.44137663-.50554151 0-.9158079.14777367-1.23079915.44137663-.31693564.29554734-.47637565.6708147-.47637565 1.11996889 0 .44332102.15360684.81469959.46470931 1.11413572.30721369.29943612.70970251.44915419 1.20357768.44915419h.01166634c.51331908 0 .92552985-.14971807 1.23663232-.44915419.31304686-.29943613.46859809-.6708147.46859809-1.11413572zM22 5.75072915V18.2492709c0 1.0344157-.3655454 1.9171689-1.100525 2.6502041C20.1664398 21.6344546 19.2836866 22 18.2492709 22H5.75072915c-1.03247132 0-1.91716897-.3655454-2.65020416-1.100525C2.36748979 20.1664398 2 19.2836866 2 18.2492709V5.75072915c0-1.03441571.36748979-1.91716897 1.10052499-2.65020416C3.83356018 2.3655454 4.71825783 2 5.75072915 2H18.2492709c1.0344157 0 1.9171689.3655454 2.6502041 1.10052499C21.6344546 3.83356018 22 4.71631344 22 5.75072915z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  );
}
export default LinkedIn;
